import React, { useState, useEffect } from 'react';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Tooltip from "@material-ui/core/Tooltip";

export interface SelectIconProps {
    selected?: boolean
    onClick?: Function
    firstOption?: String
    secondOption?: String
    icon?: JSX.Element
    color?: String
    selectText?: String,
    compare?: boolean
}

export const SelectIcon = ({ ...props }: SelectIconProps) => {
    const [isSelected, setIsSelected] = useState<boolean>(false);

    const onClick = (newClickState: boolean) => {
        if (props.onClick) {
            props.onClick(newClickState);
        }
        // do not stay toggled for add to list
        if (props.color !== 'blue') {
            setIsSelected(newClickState);
        }
    }

    useEffect(() => {
        setIsSelected(props.selected!);
    }, [props.selected]);

    return (
        <div className="d-flex">
            {props.firstOption && props.secondOption &&
                <div className="space">
                    {!isSelected ? props.firstOption : props.secondOption}
                </div>
            }
            {props.firstOption && !props.secondOption &&
                <div className={isSelected ? "space" : ""}>
                    {!isSelected ? props.firstOption : ""}
                </div>
            }
            {!props.firstOption && props.secondOption &&
                <div className={!isSelected ? "" : "space"}>
                    {!isSelected ? "" : props.secondOption}
                </div>
            }
            <Tooltip arrow placement="bottom" title={props.selectText ? props.selectText : ""}>
                <span>
                    <div onClick={() => onClick(!isSelected)} className={props.compare ? (props.color ? "circle-icon " + props.color : "circle-icon") : isSelected ? (props.color ? "selected-circle-icon " + props.color : "selected-circle-icon") : (props.color ? "circle-icon " + props.color : "circle-icon")}>
                        {props.icon ? props.icon : <CheckCircleOutlineIcon className={isSelected ? " selected" : ''} />}
                    </div>
                </span>
            </Tooltip>
        </div>
    );
}
